import type { ReactNode } from "react";

const Kanban = ({ children }: { children: ReactNode }) => {
    return (
        <div className="h-full w-full flex gap-[20px] min-w-max overflow-x-auto">
            {
                children
            }
        </div>
    );
};

export default Kanban